import Holiday from "../../../../components/company/organization/holidays";


const HolidayPage = () => {
    return <Holiday />
}

export default HolidayPage;